import React from 'react';
import { Tooltip, Fade, ClickAwayListener } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { isOnlyMobile } from '../../services/isMobile';
import StringUtils from '../../services/StringUtils';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: 13,
  },
}));

function Wrapper({ onClose, children }) {
  if (onClose) {
    return (
      <ClickAwayListener onClickAway={onClose}>
        {children}
      </ClickAwayListener>
    );
  }

  return children;
}

function TooltipWrapper({
  tip,
  children,
  open,
  hideHighlight,
  arrow,
  interactive,
  position = 'bottom',
  customClass = null,
  leaveDelay = 200,
  enterDelay = 200,
  onClose = null,
}) {
  const classes = useStyles();
  const isDisabled = StringUtils.isNilOrEmptyWithoutHtmlTags(tip);

  return (
    !isDisabled
      ? (
        <Wrapper onClose={onClose}>
          <Tooltip
            title={tip}
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 300 }}
            arrow={arrow}
            placement={position}
            disableInteractive={!interactive}
            open={open}
            disabled={hideHighlight}
            leaveDelay={leaveDelay}
            enterDelay={enterDelay}
            classes={{ tooltip: clsx(classes.tooltip, customClass) }}
            disableFocusListener={isOnlyMobile}
            disableHoverListener={isOnlyMobile}
            disableTouchListener={isOnlyMobile}
            onClose={onClose}
          >
            <div
              className={isDisabled || hideHighlight ? '' : 'withTooltip'}
            >
              {children}
            </div>
          </Tooltip>
        </Wrapper>
) : children
  );
}

export default TooltipWrapper;
